import PropTypes from 'prop-types'
import React from 'react'

export default function UserIcon({ styles }) {
  return (
    <svg
      width="22"
      style={styles}
      height="22"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.02894 14.3913H12.6954C15.2983 14.3913 17.4158 16.5088 17.4158 19.1117V19.8913H18.975V19.1117C18.975 15.6494 16.1576 12.832 12.6954 12.832H9.02894C5.56669 12.8327 2.75 15.6494 2.75 19.1117V19.8913H4.30856V19.1117C4.30856 16.5088 6.42606 14.3913 9.02894 14.3913Z"
        fill="currentColor"
      />
      <path
        d="M10.8626 11.6421C13.3135 11.6421 15.3086 9.64769 15.3086 7.19606C15.3086 4.74444 13.3135 2.75 10.8626 2.75C8.41094 2.75 6.4165 4.74444 6.4165 7.19606C6.4165 9.64769 8.41094 11.6421 10.8626 11.6421ZM10.8626 4.30856C12.4541 4.30856 13.7494 5.60381 13.7494 7.19606C13.7494 8.78762 12.4541 10.0836 10.8626 10.0836C9.27032 10.0836 7.97507 8.78831 7.97507 7.19606C7.97507 5.60381 9.27032 4.30856 10.8626 4.30856Z"
        fill="currentColor"
      />
    </svg>
  )
}

UserIcon.propTypes = {
  styles: PropTypes.any,
}
